<!-- Burbuja flotante. La esquina inferior derecha quedó libre: el chat de
     Zendesk sólo se carga para visitantes sin sesión (ver ZendeskService). -->
<ng-container *ngIf="enabled">
  <button
    class="chat-launcher"
    type="button"
    *ngIf="!open"
    (click)="toggle()"
    aria-label="Abrir asistente Sismat"
  >
    <i class="fas fa-sparkles"></i>
  </button>

  <app-chat-panel
    [open]="open"
    (openChange)="onOpenChange($event)"
    (applyTasks)="onApplyTasks($event)"
  ></app-chat-panel>
</ng-container>
